import { render, staticRenderFns } from "./TwoFAPopUp.vue?vue&type=template&id=7f464ab0&scoped=true&"
import script from "./TwoFAPopUp.vue?vue&type=script&lang=js&"
export * from "./TwoFAPopUp.vue?vue&type=script&lang=js&"
import style0 from "./TwoFAPopUp.vue?vue&type=style&index=0&id=7f464ab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f464ab0",
  null
  
)

export default component.exports